import { createFileRoute } from "@tanstack/react-router";
import { PublicDocuments } from "@/components/legal/public-documents";

/** Список документов правового центра. Открыт гостю — сессия не требуется. */
export const Route = createFileRoute("/legal/")({
	component: PublicDocuments,
});
